import { createContext, useContext, useState, ReactNode, useEffect } from "react";
import { fetchGallery } from "../api/api";

type SiteData = {
    gallery: any[];
    refreshGallery: () => void
};

const DataContext = createContext<SiteData | undefined>(undefined);

export const SiteDataProvider = ({ children }: { children: ReactNode }) => {

    const [gallery, setGallery] = useState<any[]>([]);
    const [controlGallery, setControlGallery] = useState(false)
    const refreshGallery = () => setControlGallery(!controlGallery)

    useEffect(() => {
        const fetchData = async () => {
            const data = await fetchGallery()
            setGallery(data)
        }
        fetchData()
    }, [controlGallery]);


    const value: SiteData = {
        gallery,
        refreshGallery
    };

    return <DataContext.Provider value={value}>{children}</DataContext.Provider>;
};

export const useSiteData = () => {
    const context = useContext(DataContext);
    if (!context) throw new Error("useSiteData must be used inside SiteDataProvider");
    return context;
};